import { FormFieldComponent } from "../formFieldComponent";
import { Form } from "../form";
import { IAddressLookupService } from "../../services/interfaces/addressLookupService";
import { SearchView } from "./addressComponent/searchView";
import { EditView } from "./addressComponent/editView";
import { ReadonlyView } from "./addressComponent/readonlyView";
import { IMessagingService } from "../../services";
import { ILoggingService } from "../../services/interfaces/loggingService";
import { AddressView } from "../../enums/addressView";
import { SessionDto, AddressDto } from "../../platform/models";

class AddressComponent extends FormFieldComponent {

    private searchView: SearchView;
    private readonlyView: ReadonlyView;
    private editView: EditView;
    private editViewFirstInputEl: HTMLInputElement;

    constructor(protected fieldEl: HTMLElement, messagingService: IMessagingService, form: Form, session: SessionDto, addressLookupService: IAddressLookupService, private appInsights: ILoggingService) {
        super(fieldEl, messagingService, form);

        const searchViewEl = fieldEl.querySelector<HTMLElement>(".js-search-view");
        const readonlyViewEl = fieldEl.querySelector<HTMLElement>(".js-readonly-view");
        const editViewEl = fieldEl.querySelector<HTMLElement>(".js-edit-view");
        const antiForgeryToken = fieldEl.querySelector<HTMLInputElement>("input[name='__RequestVerificationToken']")?.value || "";

        this.searchView = new SearchView(searchViewEl, this, session, addressLookupService, appInsights, antiForgeryToken);
        this.readonlyView = new ReadonlyView(readonlyViewEl, this, session, addressLookupService, appInsights, antiForgeryToken);
        this.editView = new EditView(editViewEl, this.messagingService, form, this, session, addressLookupService);
        this.editViewFirstInputEl = editViewEl.querySelector<HTMLInputElement>("input");

        this.setActiveView(AddressView.Search);
        this.searchView.show();
    }

    public resetSearch() {
        this.setValue(null);
        this.searchView.show();
        this.searchView.focus();
        this.editView.hide();
        this.readonlyView.hide();
        this.setActiveView(AddressView.Search);
    }

    public enterManualAddress() {
        this.searchView.hide();
        this.editView.show();
        if (this.editViewFirstInputEl) {
            this.editViewFirstInputEl.focus();
        }
        this.readonlyView.hide();
        this.setActiveView(AddressView.Edit);
    }

    public selectAddress(addressId: string) {
        this.searchView.hide();
        this.editView.hide();
        this.readonlyView.displayAddress(addressId);
        this.setActiveView(AddressView.ReadOnly);
    }

    public editAddress(address: AddressDto) {
        this.searchView.hide();
        this.editView.editAddress(address);
        this.readonlyView.hide();
        this.setActiveView(AddressView.Edit);
    }

    protected setDisplayValue(value: any) {

    }

    private setActiveView(view: AddressView) {
        this.fieldEl.dataset.activeView = view;
    }

    public setFocus() {

    }
}

export { AddressComponent }